import { PRIMARY } from 'constants/colors';
import { CARD_WIDTH } from 'constants/widths';
import { panelThemeColors } from '../../components/ActivityPanel/constants';

import { Box } from '@mui/material';
import { StyledExtraSmallIcon } from 'components/shared/Icon/Icon.styles';
import { formatSecondsToHoursMinutes } from 'utils/date';
import { brightness } from 'utils/misc';
import { useIsColumnLoading } from '../ColumnLoadingContext';
import { useDropTarget } from '../hooks/useDropTarget';

import type {
  DayPart,
  PlanningEntityIdentifier,
  PlanningEntityType
} from 'generated';
import type { PanelTheme } from '../../components/ActivityPanel/constants';

interface FreeTimePragmaticProps {
  id: string;
  dayPart: DayPart;
  scheduleStart: string;
  start: string;
  durationInSeconds: number;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
}

function FreeTimePragmatic({
  id: _id,
  dayPart = 'MORNING',
  scheduleStart,
  start,
  durationInSeconds,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier
}: FreeTimePragmaticProps) {
  'use memo';
  const isColumnLoading = useIsColumnLoading();

  const ref = useDropTarget({
    scheduleStart,
    start,
    planningEntityType,
    planningEntityId,
    planningEntityIdentifier,
    canDrop: !isColumnLoading
  });

  const { borderColor, textColor } = panelThemeColors[dayPart as PanelTheme];

  return (
    <Box
      component="li"
      ref={ref}
      className="freetime-container"
      sx={{
        height: '45px',
        margin: '-10px 0',
        padding: '10px 0',
        width: CARD_WIDTH,
        position: 'relative',
        zIndex: 1,
        '&:first-of-type': {
          marginTop: '-20px'
        },
        '&:last-of-type': {
          margin: '-10px 0'
        },
        '&:last-of-type:not(:first-of-type)': {
          marginTop: '0'
        },
        '+ .traveltime-container': {
          marginTop: '-25px'
        },
        '&[data-drag-over] .freetime': {
          backgroundColor: brightness(PRIMARY, 90),
          border: `2px solid ${PRIMARY}`
        }
      }}
    >
      <Box
        display="flex"
        flexShrink={0}
        justifyContent="center"
        alignItems="center"
        className="freetime"
        my={1}
        sx={{
          boxSizing: 'border-box',
          height: '30px',
          width: '100%',
          color: textColor,
          backgroundColor: 'transparent',
          fontSize: '12px',
          fontFamily: 'SourceSansPro-Regular',
          borderRadius: '4px',
          border: `1px dashed ${borderColor}`,
          transition: 'border-color 0.2s ease-in-out'
        }}
      >
        <StyledExtraSmallIcon type="clock" sx={{ marginRight: '8px' }} />
        {`${formatSecondsToHoursMinutes(durationInSeconds)} vrije ruimte`}
      </Box>
    </Box>
  );
}

export default FreeTimePragmatic;
